@if (hasChecks) {
  <forge-card class="no-padding">
    <forge-toolbar>
      <h2 class="forge-typography--heading4" slot="start">In Balance</h2>
    </forge-toolbar>
    @if (loaded) {
      <div>
        @for (provider of sortedProviders; track provider; let i = $index) {
          <div>
            <in-balance-check [index]="i" [provider]="provider.ProviderId"></in-balance-check>
          </div>
        }
      </div>
    }
  </forge-card>
}
